import { IFilterState, IEvent } from "../interfaces";
import { hashValue } from "./hash-value";
import { activeFilterOptions } from "./active-filter-options";

/**
 * Hash the current filter state and return a key (number).
 * 
 * This is used to compare filter states inside components during `shouldComponentUpdate`.
 */
export function hashFilters(...filters: (boolean | IFilterState<IEvent>)[]): number {
    const rangeRestricted: boolean = filters.some(filter => typeof filter === 'boolean') ? filters.filter(filter => typeof filter === 'boolean')[0] as boolean : false;
    const activeOptions: string[][] = (filters.filter(filter => typeof filter !== 'boolean') as IFilterState<IEvent>[]).map(filter => activeFilterOptions(filter));
    return hashValue({
        rangeRestricted,
        activeOptions
    });
}